import { GlobalSearchTabsDefinition } from '~/lib/types/navbar/global-search';
import { Path } from '~/routes/constants';

export enum GlobalSearchTabs {
  PATIENTS = 'patients',
  PATIENTS_BY_CONTACT = 'patients-by-contact',
  INQUIRIES = 'inquiries',
}

export const GlobalSearchTabsCollection: Record<
  GlobalSearchTabs,
  GlobalSearchTabsDefinition
> = {
  [GlobalSearchTabs.PATIENTS]: {
    basePath: Path.MAUD_PATIENTS,
    label: 'Patients',
  },
  [GlobalSearchTabs.PATIENTS_BY_CONTACT]: {
    basePath: Path.MAUD_PATIENTS,
    label: 'Contacts',
  },
  [GlobalSearchTabs.INQUIRIES]: {
    basePath: Path.MAUD_INQUIRIES,
    label: 'Inquiries',
  },
};
